<div class="my-1 d-flex flex-row align-items-start note-action-container hover-container">
    <adapt-link-objective [objective]="link.objective1"></adapt-link-objective>
    @if (showDeleteLink) {
        <button adaptButtonIcon="delete"
                adaptTooltip="Delete objective link"
                (click)="deleteObjectiveLink(link)"
                class="ms-auto me-2 btn btn-blank hover-action"></button>
    }
</div>
